import {
  Snackbar,
  Alert,
  Card,
  CircularProgress,
  Backdrop,
  Icon,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  Checkbox,
  Grid,
  Table,
  TableRow,
  TableCell,
  Button,
  Divider,
  FormControlLabel,
  FormGroup,
  Switch,
  ListItem,
  ListItemText,
  Chip,
  Box,
  TextField,
  Paper,
  TableContainer,
  TableHead,
  TableBody,
  IconButton,
  InputAdornment,
  ListItemIcon,
  Drawer,
} from "@mui/material";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

import MDBox from "theme/components/MDBox";
import MDTypography from "theme/components/MDTypography";
import DashboardLayout from "app/LayoutContainers/DashboardLayout";
import DashboardNavbar from "app/Navbars/DashboardNavbar";
import Footer from "theme/Footer";
import usePageTitle from "app/pageTitle";

import MDInput from "theme/components/MDInput";
import MDButton from "theme/components/MDButton";
import DataTable from "theme/Tables/DataTable";
import axios from "axios.js";
import { useAwaitDialog } from "app/components/status_dialog";
import * as XLSX from "xlsx";
import AppConfig from "appConfig";

import {
  ResponsiveContainer,
  PieChart,
  Pie,
  LabelList,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Cell,
  Tooltip,
  Legend,
  CartesianGrid,
  LineChart,
  Line,
} from "recharts";
import { useTheme } from "@mui/material/styles";
import { line } from "stylis";
import Dialer from "./components/dialer";

function BusinessLinePage() {
  const pageTitle = "Voice - Business Line";
  usePageTitle(pageTitle);
  const { ref } = useParams();
  const navigate = useNavigate();

  const theme = useTheme();
  const colors = [
    theme.palette.primary.main,
    theme.palette.info.main,
    theme.palette.success.main,
    theme.palette.warning.main,
    theme.palette.error.main,
  ];

  const statusDialog = useAwaitDialog();
  const [showLoading, setShowLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [errorMsg, setErrMsg] = useState("");
  const [severity, setSeverity] = useState("");
  const handleClose = () => {
    setOpen(false);
    setErrMsg("");
  };
  const [refreshPage, setRefreshPage] = useState(false);
  const [pageLoaded, setPageLoaded] = useState(false);
  function triggerRefresh() {
    setRefreshPage((prev) => !prev);
  }

  const [currency, setCurrency] = useState(null);
  const [businessLine, setBusinessLine] = useState(null);
  const [insights, setInsights] = useState({});
  const [resultData, setResultData] = useState({});

  const [subscription, setSubscription] = useState(null);
  const [subscriptionDuration, setSubscriptionDuration] = useState(1);
  const [openSubscriptionDialog, setOpenSubscriptionDialog] = useState(false);

  const [lineTitle, setLineTitle] = useState(null);
  const [lineNumber, setLineNumber] = useState(null);
  const [openEditDialog, setOpenEditDialog] = useState(false);

  const [dialerToken, setDialerToken] = useState(null);
  const [openDialerDialog, setOpenDialerDialog] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      setShowLoading(true);
      await axios
        .get(`/portal/voice/business_lines/${ref}/fetch.json`)
        .then((result) => {
          console.log(result.data.data);
          setShowLoading(false);
          if (result.data.status === "success") {
            setCurrency(result.data.currency);
            setResultData(result.data.data);
            setBusinessLine(result.data.data.line);

            setLineTitle(result.data.data.line.title);
            setLineNumber(result.data.data.line.receiver_phone_number);

            setSubscription(result.data.data.subscription);
            setInsights(result.data.data.insights);

            setPageLoaded(true);
          } else {
            setSeverity("error");
            setErrMsg(result.data.data.message);
            setOpen(true);
          }
        })
        .catch(() => {
          setShowLoading(false);
          setSeverity("error");
          setErrMsg(
            `Unable to complete request. ${
              navigator.onLine ? "" : "Make sure you have an active internet connection"
            }`
          );
          setOpen(true);
        });
    };

    fetchData();
  }, [refreshPage]);

  async function edit() {
    if (!lineTitle) {
      setShowLoading(false);
      setSeverity("error");
      setErrMsg("Name is required");
      return;
    }

    if (!lineNumber) {
      setShowLoading(false);
      setSeverity("error");
      setErrMsg("Receiving number is required");
      return;
    }

    setOpenEditDialog(false);
    setShowLoading(true);
    const json = {
      reference: ref,
      title: lineTitle,
      phone_number: lineNumber,
    };

    await axios
      .post("/portal/voice/business_lines/edit.json", json)
      .then(async (result) => {
        setShowLoading(false);
        if (result.data.status === "success") {
          await statusDialog.show(result.data.data.message, "success", "Success!");
          setRefreshPage(!refreshPage);
        } else {
          await statusDialog.show(result.data.data.message, "error", "Action Failed!");
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  async function subscribe() {
    setOpenSubscriptionDialog(false);
    setShowLoading(true);
    const json = {
      reference: ref,
      duration: subscriptionDuration,
    };

    await axios
      .post("/portal/voice/business_lines/subscription/subscribe.json", json)
      .then(async (result) => {
        setShowLoading(false);
        if (result.data.status === "success") {
          await statusDialog.show(result.data.data.message, "success", "Success!");
          setRefreshPage(!refreshPage);
        } else {
          await statusDialog.show(result.data.data.message, "error", "Action Failed!");
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  const formatDuration = (seconds) => {
    if (!seconds && seconds !== 0) return "00:00:00";

    const h = Math.floor(seconds / 3600);
    const m = Math.floor((seconds % 3600) / 60);
    const s = seconds % 60;

    return [
      h.toString().padStart(2, "0"),
      m.toString().padStart(2, "0"),
      s.toString().padStart(2, "0"),
    ].join(":");
  };

  async function generateToken() {
    setDialerToken(null);
    setShowLoading(true);
    await axios
      .get(`portal/voice/business_lines/${ref}/generateToken.json`)
      .then(async (result) => {
        setShowLoading(false);
        if (result.data.status === "success") {
          setDialerToken(result.data.data.token);
          // Open dialer
          setOpenDialerDialog(true);
        } else {
          await statusDialog.show(result.data.data.message, "error", "Failed!");
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={showLoading}
        onClick={handleClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={handleClose} severity={severity} sx={{ width: "100%" }}>
          {errorMsg}
        </Alert>
      </Snackbar>
      <Dialog open={openEditDialog} fullWidth maxWidth="xs">
        <DialogTitle>Edit Business Line</DialogTitle>
        <DialogContent>
          <MDBox>
            <MDBox mt={1}>
              <MDInput
                name="title"
                margin="dense"
                label="Name"
                type="text"
                fullWidth
                variant="outlined"
                value={lineTitle}
                onChange={(e) => setLineTitle(e.target.value)}
              />
            </MDBox>

            <MDBox mt={3}>
              <MDInput
                name="title"
                margin="dense"
                label="Receiving Phone Number (Inbound Calls)"
                type="text"
                fullWidth
                variant="outlined"
                value={lineNumber}
                onChange={(e) => setLineNumber(e.target.value)}
              />
              <MDTypography variant="caption" fontWeight="regular">
                Note: All incoming calls from your customers will be sent to this number
              </MDTypography>
            </MDBox>
          </MDBox>
        </DialogContent>
        <DialogActions>
          <MDButton
            onClick={() => {
              setOpenEditDialog(false);
            }}
            color="dark"
            variant="outlined"
            startIcon={<Icon>cancel</Icon>}
          >
            Cancel
          </MDButton>
          <MDButton
            onClick={() => {
              edit();
            }}
            color="dark"
            variant="contained"
            startIcon={<Icon>save</Icon>}
          >
            Save Changes
          </MDButton>
        </DialogActions>
      </Dialog>
      <Dialog open={openSubscriptionDialog} fullWidth maxWidth="xs">
        <DialogTitle>Renew Subscription</DialogTitle>
        <DialogContent>
          <MDBox>
            <MDBox mt={1}>
              <FormControl sx={{ minWidth: 120, width: "100%" }}>
                <InputLabel>Duration</InputLabel>
                <Select
                  label="Duration"
                  onChange={(e) => {
                    setSubscriptionDuration(e.target.value);
                  }}
                  sx={{ padding: "12px", paddingLeft: "3px" }}
                  value={subscriptionDuration}
                >
                  <MenuItem value={1}>30 days</MenuItem>
                  <MenuItem value={3}>90 days</MenuItem>
                  <MenuItem value={6}>180 days</MenuItem>
                  <MenuItem value={12}>365 days</MenuItem>
                </Select>
              </FormControl>
            </MDBox>
            <MDBox mt={3}>
              <Table>
                <TableRow>
                  <TableCell>
                    <MDTypography>
                      <MDTypography fontSize={12}>Price</MDTypography>
                    </MDTypography>
                  </TableCell>
                  <TableCell>
                    <MDTypography align="right" fontSize={12}>
                      {currency}
                      {((resultData.fee / 100) * subscriptionDuration).toLocaleString("en", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })}
                    </MDTypography>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>
                    <MDTypography>
                      <MDTypography fontSize={12}>VAT</MDTypography>
                    </MDTypography>
                  </TableCell>
                  <TableCell>
                    <MDTypography align="right" fontSize={12}>
                      {currency}
                      {((resultData.vat / 100) * subscriptionDuration).toLocaleString("en", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })}
                    </MDTypography>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>
                    <MDTypography>
                      <MDTypography fontSize={14} fontWeight="bold">
                        Total
                      </MDTypography>
                    </MDTypography>
                  </TableCell>
                  <TableCell>
                    <MDTypography align="right" fontWeight="bold" fontSize={14}>
                      {currency}
                      {(
                        ((resultData.fee + resultData.vat) / 100) *
                        subscriptionDuration
                      ).toLocaleString("en", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })}
                    </MDTypography>
                  </TableCell>
                </TableRow>
              </Table>
            </MDBox>
          </MDBox>
        </DialogContent>
        <DialogActions>
          <MDButton
            onClick={() => {
              setOpenSubscriptionDialog(false);
            }}
            color="dark"
            variant="outlined"
            startIcon={<Icon>cancel</Icon>}
          >
            Cancel
          </MDButton>
          <MDButton
            onClick={() => {
              subscribe();
            }}
            color="dark"
            variant="contained"
            startIcon={<Icon>payment</Icon>}
          >
            Pay
          </MDButton>
        </DialogActions>
      </Dialog>
      {dialerToken && (
        <Drawer
          anchor="right"
          open={openDialerDialog}
          onClose={(event, reason) => {
            if (reason !== "backdropClick") {
              setOpenDialerDialog(false);
            }
          }}
          sx={{
            "& .MuiDrawer-paper": {
              position: "fixed",
              top: "0 !important",
              right: "0 !important",
              margin: "0 !important",
              width: 420,
              maxWidth: "100vw",
              height: "100vh",
              borderRadius: 0,
            },
          }}
        >
          <Dialer
            dialerToken={dialerToken}
            onIncomingCall={() => {}}
            onClose={() => setOpenDialerDialog(false)}
          />
        </Drawer>
      )}

      <MDBox mt={0.5} mb={5}>
        {pageLoaded && (
          <MDBox>
            <MDBox mt={0} mb={2} display="flex" justifyContent="space-between">
              <MDBox>
                <Button
                  color="dark"
                  size="small"
                  startIcon={<Icon>west</Icon>}
                  onClick={() => {
                    navigate(`/voice/business-lines`);
                  }}
                >
                  Back
                </Button>
              </MDBox>
              <MDBox>
                <Button
                  size="small"
                  color="info"
                  iconOnly
                  onClick={() => {
                    navigate(`/voice/business-lines/calls/${ref}`);
                  }}
                  startIcon={
                    <Icon sx={{ cursor: "pointer" }} fontSize="small">
                      list_alt
                    </Icon>
                  }
                >
                  Call Logs
                </Button>
              </MDBox>
            </MDBox>

            <MDBox mt={1}>
              <Grid container spacing={3}>
                <Grid item xs={12} md={4} lg={4}>
                  <MDBox sx={{ height: "100%", marginTop: "0px" }}>
                    <Card sx={{ height: "100%", marginTop: "0px" }}>
                      <MDBox p={2}>
                        <MDBox>
                          <MDBox display="flex" justifyContent="space-between">
                            <MDBox>
                              <MDTypography variant="h6" fontWeight="light" fontSize={13}>
                                Business Line
                              </MDTypography>
                              <MDTypography variant="h6" fontWeight="bold" fontSize={16}>
                                {businessLine.title}
                              </MDTypography>
                            </MDBox>
                            <MDBox>
                              <MDButton
                                size="small"
                                variant="outlined"
                                color="warning"
                                iconOnly
                                onClick={() => {
                                  setLineTitle(businessLine.title);
                                  setLineNumber(businessLine.receiver_phone_number);
                                  setOpenEditDialog(true);
                                }}
                              >
                                <Icon sx={{ cursor: "pointer" }} fontSize="small">
                                  edit
                                </Icon>
                              </MDButton>
                            </MDBox>
                          </MDBox>
                          <MDBox>
                            <Divider />
                          </MDBox>
                          <MDBox mt={3}>
                            <MDBox
                              display="flex"
                              alignItems="center"
                              justifyContent="space-between"
                            >
                              <ListItem>
                                <ListItemIcon>
                                  <Icon color="success">phone_forwarded</Icon>
                                </ListItemIcon>
                                <ListItemText
                                  primary={
                                    <MDTypography mb={2} variant="caption" fontSize={13}>
                                      {businessLine.phone_number}
                                    </MDTypography>
                                  }
                                />
                              </ListItem>
                            </MDBox>
                            <MDBox
                              display="flex"
                              alignItems="center"
                              justifyContent="space-between"
                              mt={1}
                            >
                              <ListItem>
                                <ListItemIcon>
                                  <Icon color="warning">phone_callback</Icon>
                                </ListItemIcon>
                                <ListItemText
                                  primary={
                                    <MDTypography mb={2} variant="caption" fontSize={13}>
                                      {businessLine.receiver_phone_number}
                                    </MDTypography>
                                  }
                                />
                              </ListItem>
                            </MDBox>
                          </MDBox>
                        </MDBox>
                      </MDBox>
                    </Card>
                  </MDBox>
                </Grid>
                <Grid item xs={12} md={4} lg={4}>
                  {subscription ? (
                    <MDBox sx={{ height: "100%" }}>
                      <Card sx={{ height: "100%" }}>
                        <MDBox align="center" p={2} sx={{ height: "100%" }}>
                          <MDTypography variant="h6">Subscription</MDTypography>
                          <MDTypography mt={3} fontSize={42}>
                            <Icon color="success">check_circle</Icon>
                          </MDTypography>
                          <MDBox mt={0}>
                            <MDTypography variant="caption">Expires On</MDTypography>
                            <MDTypography fontSize={14}>{subscription.end}</MDTypography>
                          </MDBox>
                        </MDBox>
                      </Card>
                    </MDBox>
                  ) : (
                    <Card>
                      <MDBox p={2}>
                        <MDBox align="center">
                          <MDTypography variant="h6" fontSize={48}>
                            <Icon color="error">warning</Icon>
                          </MDTypography>
                          <MDTypography variant="h6" fontSize={14} fontWeight="light">
                            No active subscription!
                          </MDTypography>
                          <MDBox>
                            <Divider />
                          </MDBox>
                          <MDBox mt={2} align="center">
                            <MDButton
                              size="small"
                              variant="contained"
                              color="dark"
                              startIcon={<Icon>money</Icon>}
                              onClick={() => {
                                setSubscriptionDuration(1);
                                setOpenSubscriptionDialog(true);
                              }}
                            >
                              Renew
                            </MDButton>
                          </MDBox>
                        </MDBox>
                      </MDBox>
                    </Card>
                  )}
                </Grid>
                <Grid item xs={12} md={4} lg={4}>
                  <MDBox sx={{ height: "100%", marginTop: "0px" }}>
                    <Card sx={{ height: "100%", marginTop: "0px" }}>
                      <MDBox p={2} align="center">
                        <MDBox>
                          <MDBox>
                            <MDTypography variant="h6" fontWeight="bold" fontSize={16}>
                              Dialer
                            </MDTypography>
                          </MDBox>
                          <MDBox>
                            <Divider />
                          </MDBox>
                          <MDBox>
                            <MDTypography fontSize={46}>
                              <Icon>call</Icon>
                            </MDTypography>
                          </MDBox>
                          <MDBox>
                            <MDButton
                              size="small"
                              variant="outlined"
                              color="dark"
                              startIcon={<Icon>north_east</Icon>}
                              onClick={() => {
                                generateToken();
                              }}
                            >
                              Open Dialer
                            </MDButton>
                          </MDBox>
                        </MDBox>
                      </MDBox>
                    </Card>
                  </MDBox>
                </Grid>
              </Grid>
            </MDBox>
            <MDBox mt={5}>
              <Grid container spacing={3}>
                <Grid item xs={12} md={2.4} lg={2.4}>
                  <MDBox sx={{ height: "100%" }}>
                    <Card sx={{ height: "100%" }}>
                      <MDBox p={2} textAlign="center">
                        <MDTypography fontSize={24}>
                          <Icon>call</Icon>
                        </MDTypography>
                        <MDTypography variant="h4">{insights.totals.total_calls}</MDTypography>
                        <MDTypography variant="caption">Total Calls</MDTypography>
                      </MDBox>
                    </Card>
                  </MDBox>
                </Grid>
                <Grid item xs={6} md={2.4} lg={2.4}>
                  <MDBox sx={{ height: "100%" }}>
                    <Card sx={{ height: "100%" }}>
                      <MDBox p={2} textAlign="center">
                        <MDTypography fontSize={24}>
                          <Icon>phone_callback</Icon>
                        </MDTypography>
                        <MDTypography variant="h4">{insights.totals.inbound_calls}</MDTypography>
                        <MDTypography variant="caption">Incoming Calls</MDTypography>
                      </MDBox>
                    </Card>
                  </MDBox>
                </Grid>
                <Grid item xs={6} md={2.4} lg={2.4}>
                  <MDBox sx={{ height: "100%" }}>
                    <Card sx={{ height: "100%" }}>
                      <MDBox p={2} textAlign="center">
                        <MDTypography fontSize={24}>
                          <Icon>phone_forwarded</Icon>
                        </MDTypography>
                        <MDTypography variant="h4">{insights.totals.outbound_calls}</MDTypography>
                        <MDTypography variant="caption">Outgoing Calls</MDTypography>
                      </MDBox>
                    </Card>
                  </MDBox>
                </Grid>
                <Grid item xs={12} md={2.4} lg={2.4}>
                  <MDBox sx={{ height: "100%" }}>
                    <Card sx={{ height: "100%" }}>
                      <MDBox p={2} textAlign="center">
                        <MDTypography fontSize={24}>
                          <Icon>access_time</Icon>
                        </MDTypography>
                        <MDTypography variant="h4">
                          {formatDuration(insights.totals.total_duration)}
                        </MDTypography>
                        <MDTypography variant="caption">Talk Time</MDTypography>
                      </MDBox>
                    </Card>
                  </MDBox>
                </Grid>
                <Grid item xs={12} md={2.4} lg={2.4}>
                  <MDBox sx={{ height: "100%" }}>
                    <Card sx={{ height: "100%" }}>
                      <MDBox p={2} textAlign="center">
                        <MDTypography fontSize={24}>
                          <Icon>av_timer</Icon>
                        </MDTypography>
                        <MDTypography variant="h4">
                          {formatDuration(insights.averages.avg_duration.toFixed(0))}
                        </MDTypography>
                        <MDTypography variant="caption">Avg Time</MDTypography>
                      </MDBox>
                    </Card>
                  </MDBox>
                </Grid>
              </Grid>
            </MDBox>
            <MDBox mt={5}>
              <Card>
                <MDBox p={2}>
                  <MDBox align="left">
                    <MDTypography variant="h6">Call Status</MDTypography>
                  </MDBox>
                  <MDBox mt={1}>
                    <ResponsiveContainer width="100%" height={240}>
                      <BarChart
                        data={insights.breakdowns.status}
                        layout="vertical"
                        barCategoryGap="10%"
                      >
                        <XAxis type="number" tick={{ fontSize: 12 }} />
                        <YAxis dataKey="status" type="category" tick={{ fontSize: 12 }} />
                        <Tooltip />
                        <Bar dataKey="count" minPointSize={5}>
                          {insights.breakdowns.status.map((entry, index) => {
                            let color = theme.palette.grey[400];

                            if (entry.status === "completed") color = theme.palette.success.main;
                            else if (entry.status === "missed") color = theme.palette.error.main;
                            else if (entry.status === "dropped") color = theme.palette.dark.main;

                            return <Cell key={index} fill={color} />;
                          })}
                        </Bar>
                      </BarChart>
                    </ResponsiveContainer>
                  </MDBox>
                </MDBox>
              </Card>
            </MDBox>
            <MDBox mt={5}>
              <Card sx={{ height: "100%" }}>
                <MDBox p={2}>
                  <MDTypography mb={3} variant="h6">
                    7-day Trend
                  </MDTypography>

                  <ResponsiveContainer width="100%" height={300}>
                    <LineChart data={insights.daily_trend || []}>
                      <CartesianGrid strokeDasharray="3 3" />

                      <XAxis dataKey="date" />

                      <YAxis />

                      <Tooltip />

                      <Legend />

                      <Line
                        type="monotone"
                        dataKey="total"
                        name="Total"
                        stroke="#111827"
                        strokeWidth={3}
                      />

                      <Line
                        type="monotone"
                        dataKey="completed"
                        name="Completed"
                        stroke="#4caf50"
                        strokeWidth={2}
                      />

                      <Line
                        type="monotone"
                        dataKey="dropped"
                        name="Dropped"
                        stroke="#ff9800"
                        strokeWidth={2}
                      />

                      <Line
                        type="monotone"
                        dataKey="missed"
                        name="Missed"
                        stroke="#f44336"
                        strokeWidth={2}
                      />
                    </LineChart>
                  </ResponsiveContainer>
                </MDBox>
              </Card>
            </MDBox>
            <MDBox mt={5}>
              <Grid container spacing={3}>
                <Grid item xs={12} md={5} lg={5}>
                  <MDBox sx={{ height: "100%" }}>
                    <MDBox>
                      <Card>
                        <MDBox p={2} textAlign="center">
                          <MDTypography fontSize={24}>{currency}</MDTypography>
                          <MDTypography variant="h6" fontSize={24}>
                            {`${(insights.financials.total_spent / 100).toLocaleString("en", {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })}`}
                          </MDTypography>
                          <MDTypography variant="caption">Total Spend</MDTypography>
                        </MDBox>
                      </Card>
                    </MDBox>
                    <MDBox mt={1.5}>
                      <Card>
                        <MDBox p={2} textAlign="center">
                          <MDTypography fontSize={24}>{currency}</MDTypography>
                          <MDTypography variant="h6" fontSize={24}>
                            {`${(insights.averages.avg_charge / 100).toLocaleString("en", {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })}`}
                          </MDTypography>
                          <MDTypography variant="caption">Avg Spend</MDTypography>
                        </MDBox>
                      </Card>
                    </MDBox>
                  </MDBox>
                </Grid>
                <Grid item xs={12} md={7} lg={7}>
                  <Card>
                    <MDBox p={2}>
                      <MDTypography variant="h6">Spend Breakdown</MDTypography>
                      <MDBox>
                        <ResponsiveContainer width="100%" height={240}>
                          <PieChart>
                            <Pie
                              data={insights.financials.spend_per_direction}
                              dataKey="total"
                              nameKey="direction"
                              outerRadius={70}
                              animationDuration={600}
                              labelLine={false}
                              label={({ name, percent, x, y }) => (
                                <text
                                  x={x}
                                  y={y}
                                  fontSize={12}
                                  textAnchor="middle"
                                  dominantBaseline="central"
                                  fill="#666"
                                >
                                  {`${name} (${(percent * 100).toFixed(0)}%)`}
                                </text>
                              )}
                            >
                              {insights.financials.spend_per_direction.map((entry, index) => (
                                <Cell key={index} fill={colors[index % colors.length]} />
                              ))}
                            </Pie>
                            <Tooltip
                              formatter={(value) =>
                                `${currency}${(value / 100).toLocaleString("en", {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                })}`
                              }
                            />
                            <Legend />
                          </PieChart>
                        </ResponsiveContainer>
                      </MDBox>
                    </MDBox>
                  </Card>
                </Grid>
              </Grid>
            </MDBox>
          </MDBox>
        )}
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default BusinessLinePage;
